module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/partials/catalogo-detalles-default/catalogo-detalles-default.component.scss
// module id = ./src/app/components/partials/catalogo-detalles-default/catalogo-detalles-default.component.scss
// module chunks = main